import "./table.style.scss";

import { findSubPromotorAndUpdateCount } from "../../utils/reports/tally-counts/promotor-count";

import { selectClassName } from "../../utils/reports/classname";
import { returnTableRows } from "../../utils/reports/reports-table/main-table-rows";

import { USER_AND_ENTRY_TYPES } from "../../utils/user/user-types";
import { SALES_TYPES } from "../../utils/sales/sales-type";
import {formatDate} from '../../utils/guest-list/helpers';

export const TableType = {
  REFUND: 'Refund',
  MAIN: 'Main'
};

const TableReports = ({
  dataArray,
  tableHeaders,
  tableType = TableType.MAIN
}) => {
  function renderMainReport() {
    return (
      <tbody>
        {dataArray.map(([key, tally]) => {
          const className = selectClassName(
            tally.promotor ? tally.promotor.userType : tally.userType
          );
          const userType = tally.userType;
          const saleType = dataArray[0][1]['saleType'];

          // promotors main table:
          if (dataArray[0][0] === USER_AND_ENTRY_TYPES['WALK UP']) {
            findSubPromotorAndUpdateCount(tally, dataArray);
            return returnTableRows(tally, key, className);
          }

          // staff main table:
          else if (
            userType !== USER_AND_ENTRY_TYPES.PROMOTOR &&
            userType !== USER_AND_ENTRY_TYPES.SUB_PROMOTOR &&
            tally.saleType !== SALES_TYPES.BOTTLE_SALES &&
            tally.saleType !== SALES_TYPES.BAR_TABS
          ) {
            return returnTableRows(tally, key, className);
          }

          // bottle sales table:
          else if (saleType === SALES_TYPES.BOTTLE_SALES) {
            return (
              <tr className="report-table-data" key={key}>
                <td className={className}>{tally.name}</td>
                <td className={className}> {tally.promotorName} </td>
                <td className={className}> {tally.partySize} </td>
                <td className={className}> {tally.tableNumber} </td>
                <td className={className}> {tally.minimum} </td>
                <td className={className}> {tally.totalRevenue} </td>
                <td className={className}> {tally.comments} </td>
              </tr>
            );
          }

          // bar tabs table:
          else {
            return (
              <tr className="report-table-data" key={key}>
                <td className={className}>{tally.name}</td>
                <td className={className}> {tally.promotorName} </td>
                <td className={className}> {tally.partySize} </td>
                <td className={className}> {tally.minTabs} </td>
                <td className={className}> {tally.comments} </td>
              </tr>
            );
          }
        })}
      </tbody>
    );
  }

  function renderRefundReport() {
    let className = 'PROMOTOR';

    return (
      <tbody>
        {dataArray.map((item) => {
          let paidPrice = item.transaction?.paidPrice;

          let additionalTicketQuanitity =
            (item.transaction?.additionalTicketQuanitity ?? 0) + 1;
          let finalPrice = paidPrice / additionalTicketQuanitity;

          let containerStyle = item?.isAdditionalTicket
            ? 'report-table-data-additional'
            : 'report-table-data';
          return (
            <tr className={containerStyle} key={item.id}>
              <td className={className}>{item.fullName}</td>
              <td className={className}>{item.email}</td>
              <td className={className}> {item.invitedBy?.fullName ?? ''} </td>
              <td className={className}>
                {item.ticket?.ticketType?.name ?? ''}
              </td>
              <td className={className}>{`$${finalPrice}`}</td>
              <td className={className}> {formatDate(item.createdAt)} </td>
              <td className={className}>
                {item.isAdditionalTicket ? 'Yes' : 'No'}
              </td>
              <td className={className}>
                {item.isAdditionalTicket ? item.ownerEmail : ''}
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  }

  return (
    <table className="styled-table">
      <thead>
        <tr className="report-table-header">
          {tableHeaders.map((header) => {
            return <th key={header}> {header}</th>;
          })}
        </tr>
      </thead>
      {tableType === TableType.MAIN ? renderMainReport() : renderRefundReport()}
    </table>
  );
};

export default TableReports;
